module.exports = __webpack_public_path__ + "img/About_fw_1.4afe89a8.png";